export default "__VITE_ASSET__DvJ5tyf$__"